import { getNotificationCount, getNotifications } from '@/services/notification/notification'
import { Notification } from '@/services/notification/notification.model'
import { RootState } from '@/store'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface NotificationStore {
  count: number
  notifications: Notification.Info[]
}

const initialState: NotificationStore = {
  count: 0,
  notifications: []
}

export const fetchNotifications = createAsyncThunk('notification/fetchNotifications', async () => {
  return await getNotifications()
})

export const fetchNotificationCount = createAsyncThunk('notification/fetchNotificationCount', async () => {
  return await getNotificationCount()
})

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<Notification.Info[]>) => {
      state.notifications = action.payload
    },
    setNotificationCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.fulfilled, (state, action) => {
      state.notifications = action.payload
    })
    builder.addCase(fetchNotificationCount.fulfilled, (state, action) => {
      state.count = action.payload
    })
  }
})

export const { setNotifications, setNotificationCount } = notificationSlice.actions

export const selectNotification = (state: RootState) => state.notification
